module.exports = __webpack_public_path__ + "static/media/reward.c48395d0.PNG";